require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./coding-interview-prep-data-structures-create-a-linked-list-class.json") })
        }
      }, "path---coding-interview-prep-data-structures-create-a-linked-list-class");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---coding-interview-prep-data-structures-create-a-linked-list-class!./.cache/json/coding-interview-prep-data-structures-create-a-linked-list-class.json
// module id = 1309
// module chunks = 231608221292675